// Roman campaign ledger palette (mirrors the CSS variables in styles/index.css) + shared
// inline-style tokens so every surface draws from one parchment-&-ink system.
export const C = {
  paper: '#ece1c4', paperRaised: '#f5eed8', paperSunken: '#e3d6b4', paperRail: '#e7dcbf',
  ink: '#2c2316', inkSoft: '#6a5b41', inkFaint: '#9a8a68',
  rule: '#cdbb93', ruleStrong: '#b09a6b',
  gold: '#936f24', goldBright: '#b5862f', crimson: '#8c3a2e', green: '#4f6b30',
  highlight: '#e6d29a', shadow: 'rgba(60,45,18,0.18)',
}

// ── heraldry: tame a bright DB faction color into a muted, aged-map tone ──────
const hexToRgb = (hex) => { hex = String(hex).replace('#', ''); if (hex.length === 3) hex = hex.split('').map(c => c + c).join(''); const n = parseInt(hex, 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255] }
const rgbToHsl = (r, g, b) => {
  r /= 255; g /= 255; b /= 255
  const max = Math.max(r, g, b), min = Math.min(r, g, b); let h, s; const l = (max + min) / 2
  if (max === min) { h = s = 0 } else {
    const d = max - min; s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) { case r: h = (g - b) / d + (g < b ? 6 : 0); break; case g: h = (b - r) / d + 2; break; default: h = (r - g) / d + 4 }
    h /= 6
  }
  return [h, s, l]
}
const hslToRgb = (h, s, l) => {
  if (s === 0) { const v = Math.round(l * 255); return [v, v, v] }
  const hue = (p, q, t) => { if (t < 0) t += 1; if (t > 1) t -= 1; if (t < 1 / 6) return p + (q - p) * 6 * t; if (t < 1 / 2) return q; if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6; return p }
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s, p = 2 * l - q
  return [hue(p, q, h + 1 / 3), hue(p, q, h), hue(p, q, h - 1 / 3)].map(v => Math.round(v * 255))
}
const toHex = (rgb) => '#' + rgb.map(v => Math.max(0, Math.min(255, v)).toString(16).padStart(2, '0')).join('')

// Desaturate toward heraldic richness and settle lightness into a mid, aged tone.
export const muteColor = (hex, { sat = 0.55, l = null } = {}) => {
  try {
    const [h, s, lig] = rgbToHsl(...hexToRgb(hex))
    const ns = Math.min(s, s * sat + 0.06)
    const nl = l != null ? l : Math.max(0.30, Math.min(0.49, lig * 0.8))
    return toHex(hslToRgb(h, ns, nl))
  } catch { return hex }
}

// ── shared inline-style tokens ───────────────────────────────────────────────
export const ui = {
  h: { fontFamily: "'Cinzel', serif", textTransform: 'uppercase', fontSize: 11, letterSpacing: 1.5, color: C.gold, margin: '18px 0 8px', fontWeight: 600 },
  input: { width: '100%', padding: '7px 9px', borderRadius: 4, border: `1px solid ${C.rule}`, background: C.paperSunken, color: C.ink, marginBottom: 6 },
  btn: { padding: '7px 12px', borderRadius: 4, border: `1px solid ${C.gold}`, background: C.gold, color: C.paperRaised, cursor: 'pointer', fontSize: 13, letterSpacing: 0.2 },
  btnGhost: { padding: '7px 12px', borderRadius: 4, border: `1px solid ${C.rule}`, background: C.paperRaised, color: C.ink, cursor: 'pointer', fontSize: 13 },
  card: { background: C.paperRaised, border: `1px solid ${C.rule}`, borderRadius: 6 },
  row: { display: 'flex', gap: 6 },
}
